import * as Styled from './PunchupSendTicketsTitleSection.styles';

import { Icon } from 'features/common/components/Icon';
import { SendTicketsTitleSectionProps } from '../../types';

export const PunchupSendTicketsTitleSection = ({ title, streetAddress }: SendTicketsTitleSectionProps) => (
	<Styled.Wrapper>
		<Styled.Title>{title}</Styled.Title>
		<Styled.Location>
			<Icon iconName="locationPin" />
			{streetAddress}
		</Styled.Location>
	</Styled.Wrapper>
);
